export default __webpack_public_path__ + "static/banner1-9b963fa3151797f3e64d02f7ec76bb75.png";